<template>
  <div class="setAdmin">
    <el-dialog
      title="设置管理员"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="900px"
      :before-close="close"
    >
      <div class="title">
        <el-button size="small" type="primary" @click="openHandleAdmin"
          >添加管理员</el-button
        >
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="管理员姓名" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.nickName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="管理员手机号" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.mobile || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="200" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="handleDelete(row.userId)"
              >删除管理员</span
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 添加管理员 -->
    <HandleAdmin ref="handleAdminRef" />
  </div>
</template>

<script>
import {
  getCompanyAdminUserPageList,
  delUserAdminRoleToCompany,
} from "@/api/organization";
import HandleAdmin from "@/views/organization/components/handleAdmin.vue";
import myPagination from "@/components/myPagination.vue";
export default {
  components: {
    myPagination,
    HandleAdmin,
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      companyId: "",
    };
  },
  methods: {
    // 删除
    handleDelete(userId) {
      this.$confirm("确认要删除该管理员吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delUserAdminRoleToCompany({ companyId: this.companyId, userId }).then(
            (res) => {
              if (res.code === 0) {
                if (this.pageInfo.total >= this.pageInfo.limit) {
                  let sum = this.pageInfo.total % this.pageInfo.limit;
                  if (sum === 1) {
                    this.pageInfo.page =
                      Number(this.pageInfo.page) === 1
                        ? 1
                        : Number(this.pageInfo.page) - 1;
                  }
                }
                this.refresh();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    // 刷新
    refresh() {
      this.getCompanyAdminUserPageList({
        page: this.pageInfo.page,
        limit: this.pageInfo.limit,
      });
    },
    // 添加管理员
    openHandleAdmin() {
      this.$refs.handleAdminRef.init(this.companyId);
    },
    async getCompanyAdminUserPageList(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getCompanyAdminUserPageList({
        ...payload,
        companyId: this.companyId,
      });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 初始化
    init(companyId) {
      this.companyId = companyId || "";
      this.getCompanyAdminUserPageList({ page: 1, limit: 10 });
      this.dialogVisible = true;
    },
    // 关闭
    close() {
      this.dialogVisible = false;
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getCompanyAdminUserPageList({
        page: payload,
        limit: this.pageInfo.limit,
      });
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getCompanyAdminUserPageList({ page: 1, limit: payload });
    },
  },
};
</script>

<style lang="scss" scoped>
.setAdmin {
  .title {
    margin: 0px 0 10px;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>